import React from 'react'
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  TextField,
  Typography,
  colors,
  Box,
} from '@mui/material'
import { prettyPrintPhoneNumber } from '../../utils/string'
import { getIdentityName } from '../../utils/identity'
import { TASK_STATUS_TYPES, TASK_TYPES } from '../../constants'
import { CalendarMonth } from '@mui/icons-material'
import { addTimezoneOffsetToTimestamp } from '../../utils/date'
import { grey } from '@mui/material/colors'
import TaskOutcome from '../../common/TaskOutcome'

const PhoneModal = ({
  contact,
  isOpen,
  onCloseModal,
  onSave,
  note,
  date,
  setNote,
  setDate,
  today,
  isEditing,
  customer,
  handleClose,
  outcomeMode,
  setOutcomeMode,
  onSaveProp,
  task,
}) => {
  const handleSubmit = (type) => {
    if (!date) return
    onSave(TASK_TYPES.PHONE_CALL, type)
  }

  const customerOrContactName = contact
    ? getIdentityName(contact)
    : customer?.name

  const resolvedPhoneNumber = contact?.phoneNumber || customer?.primaryPhone

  const dateDisplay = addTimezoneOffsetToTimestamp(
    new Date(date)
  ).toLocaleDateString()

  return (
    <Dialog open={isOpen} onClose={handleClose} fullWidth maxWidth={'md'}>
      <DialogTitle>
        Phone Call
        {customerOrContactName ? ` with ${customerOrContactName}` : ''}
      </DialogTitle>

      {outcomeMode && (
        <TaskOutcome
          taskType={TASK_TYPES.PHONE_CALL}
          onSaveProp={onSaveProp}
          task={task}
          onClose={handleClose || onCloseModal}
          customer={customer}
          contact={contact}
          setOutcomeMode={setOutcomeMode}
        />
      )}

      {!outcomeMode && (
        <>
          <DialogContent>
            {resolvedPhoneNumber && (
              <Typography variant='h5' sx={{ mb: 2 }}>
                {prettyPrintPhoneNumber(resolvedPhoneNumber)}
              </Typography>
            )}
            {!resolvedPhoneNumber && (
              <Typography variant='h5' sx={{ color: colors.grey[400], mb: 2 }}>
                <i>No phone number provided</i>
              </Typography>
            )}
            <TextField
              sx={{ mt: 2 }}
              label={'Change date'}
              type={'date'}
              margin='dense'
              // fullWidth
              InputProps={
                {
                  // endAdornment: <span>Calendar</span>,
                }
              }
              InputLabelProps={{
                shrink: true,
              }}
              value={date}
              onChange={(e) => {
                setDate(e.target.value)
              }}
            ></TextField>
            <Typography
              sx={{ fontStyle: 'italic', fontSize: '14px', color: grey[800] }}
            >
              Use the input above to change the date.
            </Typography>
            <TextField
              onChange={(e) => setNote(e.target.value)}
              value={note}
              margin='dense'
              label={'Note'}
              fullWidth
              multiline
              rows={4}
            ></TextField>
          </DialogContent>
          <DialogActions>
            <Button onClick={onCloseModal}>
              {isEditing ? 'Close' : 'Cancel'}
            </Button>

            {isEditing && (
              <Button variant={'outlined'} onClick={() => onSave()}>
                Save
              </Button>
            )}

            {!isEditing && (
              <>
                {date <= today && (
                  <Button
                    onClick={() => handleSubmit(TASK_STATUS_TYPES.DONE)}
                    variant={'outlined'}
                  >
                    Phone call was made on {dateDisplay}
                  </Button>
                )}
                {date >= today && (
                  <Button
                    onClick={() => handleSubmit(TASK_STATUS_TYPES.NOT_STARTED)}
                    color={'primary'}
                    variant={'contained'}
                  >
                    Schedule phone call for {dateDisplay}
                  </Button>
                )}
              </>
            )}
          </DialogActions>
        </>
      )}
    </Dialog>
  )
}

export default PhoneModal
